declare global {
    interface Window {
        env: {
            REACT_APP_SSO_APP_ID: string
            REACT_APP_SSO_AUDIENCE_API: string
            REACT_APP_SSO_RETURN_ENDPOINT: string

            REACT_APP_API_BASE_URL: string
            REACT_APP_API_URL_PREFIX: string

            REACT_APP_API_SSE_URL: string

            REACT_APP_MAINTENANCE_MODE: boolean

            REACT_APP_FULL_STORY_ORG: string
            REACT_APP_FULL_STORY_ON: boolean
            REACT_APP_SENTRY_DSN: string
            REACT_APP_SENTRY_SLUG: string
            REACT_APP_ENV: 'development' | 'staging' | 'demo' | 'production'

            REACT_APP_LAUNCH_DARKLY_CLIENT_ID: string
            REACT_APP_MICROSOFT_APP_CLIENT_ID: string
            REACT_APP_MICROSOFT_FRAUD_DEFENSE_CLIENT_ID: string
            REACT_APP_GOOGLE_WORKSPACE_ASM_CLIENT_ID: string
            REACT_APP_GOOGLE_INTEGRATION_SCOPE: string

            REACT_APP_INTERCOM_API_BASE: string
            REACT_APP_INTERCOM_APP_ID: string
            REACT_APP_CS_RSA_ENC_KEY: string

            REACT_APP_MIXPANEL_ON: string
            REACT_APP_MIXPANEL_TOKEN: string

            REACT_APP_TERMS_AND_CONDITIONS_URL: string
        }
    }
}

const envVars = Object.assign({}, import.meta.env, window.env)

export { envVars }
